<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <!-- <bita-bootbutton
                v-if="!showForm"
                type="primary"
                title="باربری جدید"
                icon="fas fa-plus-square"
                btn-width="200px"
                @click.native="statusChangeModalCreate"
            /> -->
          <hr />
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :hasRow="false"
            :resizable="true"
            :schema-total="'total'"
            :schema-data="'data'"
            :server-paging="true"
            :batch="true"
          />
        </div>
      </bita-ibox>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        { title: "مدیریت کاربران", link: "/" },
        { title: "مدیریت گندله", link: "/management/gondole", active: true },
      ],
      isLoading: false,
      isLoadingGrid: false,
      gridColumns: [
        { title: "#", template: this.$getTemplate, width: "40px" },
        {
          field: "name",
          title: "نام راننده",
          template: (e) => (e.name ? e.name : " - "),
          width: "100px",
        },
        {
          field: "name",
          title: "کد ملی",
          template: (e) => (e.national_code ? e.national_code : " - "),
          width: "100px",
        },
        {
          field: "name",
          title: "نوع ماشین",
          template: (e) =>
            e.vehicle && e.vehicle.name ? e.vehicle.name : " - ",
          width: "100px",
        },
        {
          title: "عملیات",
          command: [],
          width: "150px",
        },
      ],
    };
  },
  mounted() {
    this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
  },
  methods: {
    readData(e) {
      this.$resetGrid();
      this.isLoadingGrid = true;
      this.$persistClient("get", "drivers?include=user")
        .then((res) => {
          e.success(res.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    gridCommands() {
      let commands = [];
      commands.push({
        text: "edit",
        click: this.edit,
        template: this.gridButtons.edit,
      });
      commands.push({
        text: "delete",
        click: this.delete,
        template: this.gridButtons.delete,
      });
      return commands;
    },
  },
};
</script>
